var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.694 35.694",
    enableBackground: "new 0 0 35.694 35.694",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#009E11",
    d: "M9.893,16.68c0.374-0.005,0.676,0.144,0.936,0.405c1.35,1.355,2.709,2.701,4.049,4.064 c0.241,0.245,0.379,0.278,0.64,0.015c3.076-3.095,6.165-6.178,9.249-9.266c0.25-0.25,0.503-0.49,0.876-0.538 c0.48-0.061,0.97,0.186,1.189,0.599c0.248,0.469,0.187,1.027-0.198,1.42c-0.8,0.819-1.615,1.623-2.424,2.433 c-2.609,2.61-5.219,5.219-7.829,7.829c-0.124,0.124-0.245,0.251-0.377,0.366c-0.477,0.417-1.063,0.462-1.543,0.045 c-0.547-0.475-1.05-1.002-1.564-1.514c-1.048-1.043-2.092-2.091-3.138-3.137c-0.238-0.238-0.495-0.459-0.711-0.715 c-0.347-0.413-0.444-0.878-0.203-1.39C9.058,16.848,9.43,16.69,9.893,16.68z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#009E11",
    strokeWidth: 1.6944,
    strokeMiterlimit: 10,
    cx: 17.847,
    cy: 17.847,
    r: 17
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/Right.15079e5fce7db00c655330ed6549fd16.svg";
export { ForwardRef as ReactComponent };